module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar-date-fill-7084fda5.svg";